const person = [
  "M3.8 4.2a4.2 4.2 0 1 1 5.71 3.92c4.86.81 5.93 5.43 5.93 5.43A2 2 0 0 1 13.49 16H2.5a2 2 0 0 1-1.95-2.45S1.63 8.93 6.5 8.12A4.2 4.2 0 0 1 3.8 4.2z"
];
export {
  person
};
//# sourceMappingURL=person.js.map
